<template>
  <v-container fluid grid-list-md fill-height class="godawn-details">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <router-link to="/Dashboard">
            <v-btn icon dark >
              <v-icon>keyboard_backspace</v-icon>
            </v-btn>
          </router-link>
          <v-toolbar-title >STORE INVENTORY</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout row wrap>
          <v-flex xs12 md12>
            <v-card-text>
              <v-layout row wrap>
                <v-flex
                  xs12
                  md3
                  sm3
                  v-for="godawn in godawnByBrand"
                  :key="godawn['.key']"
                  style="padding:15px"
                >
                  <v-card class="icon-card">
                    <v-icon style="padding: 18px 18px;">business</v-icon>
                  </v-card>
                  <v-card class="sec1-card" :key="godawn['.key']+'G'">
                    <v-card-title primary-title class="headline">
                      <v-spacer />
                      {{godawn.godawnName}}
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <b class="subheading primary--text font-weight-light">{{godawn.godawnAddress}}</b>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <span>{{godawn.godawnPincode}}</span>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                        <v-btn outline class="primary white--text" @click="openGodawnReports(godawn)">
                          <v-icon left class="primary--text">remove_red_eye</v-icon>
                            <a class="primary--text font-weight-light">View</a>
                        </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>  
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-flex>
         </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="viewReports" fullscreen hide-overlay>
      <v-card v-if="currentGodawn">
        <v-card-title class="primary white--text">
          <span class="headline">{{currentGodawn.godawnName}} - Reports</span>
          <v-spacer />
          <v-btn icon dark @click.native="viewReports = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
                <v-data-table
              :headers="productListHeader"
              :items="reportProducts"
              hide-actions
              class="elevation-1 dashboardHead  stocks-reports"
            >
    <template slot="headers" slot-scope="props">
  <tr>
    <th>Sr
    </th>
    <!-- <th>Action</th> -->
    <!-- <th>Name, Description, HSN, GST type, Rate, Unit</th> -->
    <th>
      <span style="font-size: 20px;">NAME - Description</span>
      <!-- <br>
      <span>HSN-GST-RATE-UNIT</span> -->
    </th>
    <th>
      <span style="font-size: 20px;">Opening Stock</span>
      <br>
      <span style="float: left;">Quantity</span>
      <span style="float: right;">Amount</span>
    </th>
    
    <th>
      <span style="font-size: 20px;">Purchase Stock</span>
      <br>
      <span style="float: left;">Quantity</span>
      <span style="float: right;">Amount</span>
    </th>

    <th>
      <span style="font-size: 20px;">Sales Stock</span>
      <br>
      <span style="float: left;">Quantity</span>
      <span style="float: right;">Amount</span>
    </th>
    
    <th>
      <span style="font-size: 20px;">Transfer</span>
      <br>
      <span style="float: left;">Quantity</span>
      <span style="float: right;">Amount</span>
    </th>
  </tr>
</template>
      <template slot="items" slot-scope="props">
      <tr>
        <td style="text-align : center">
          <b v-if="props.item['name'] != 'Total'">{{props.index + 1}}</b>
        </td>
        <!-- <td style="text-align : center">
          <v-icon v-if="props.item['name'] != 'Total'" @click="openProdItems(props.item)" color="primary">remove_red_eye</v-icon>
        </td> -->
        <td>
          <b>{{ props.item['name']}}</b>
        <td>
          <span style="float: left;"><b class="font-weight-bold info--text" >{{ props.item['reportDetails'].opening}}</b></span>
          <span style="float: right;"><b >{{ props.item['reportDetails'].openingAmount || 0 | amount }}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold primary--text" >{{ props.item['reportDetails'].purchase}}</b></span>
          <span style="float: right;"><b> {{ props.item['reportDetails'].purchaseAmount || 0 | amount}}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold green--text" >{{props.item['reportDetails'].sale}}</b></span>
          <span style="float: right;"><b> {{ props.item['reportDetails'].saleAmount || 0 | amount}}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold red--text">{{props.item['reportDetails'].transfer }}</b></span>
          <span style="float: right;"><b> {{ props.item['reportDetails'].transferAmount || 0 | amount}}</b></span>
        </td>
      </tr>
      </template>
      <template slot="no-data">No Items</template>
    </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      viewReports : false,
      currentGodawn : null,
      reportProducts : [],
            productListHeader: [
        { text: "Invoices", value: "action" },
        { text: "Name, Description, HSN, GST type, Rate, Unit", value: "Name" },
        { text: "Quantity", value: "quantity" },
        { text: "Duration quantity", value: "quantity" },
        { text: "Amount", value: "quantity" },
        { text: "Opening Quantity", value: "quantity" },
        { text: "Sale Quantity", value: "quantity" },
        { text: "Duration Sale quantity", value: "quantity" },
        { text: "Sale Amount", value: "quantity" },
        { text: "Purchase Quantity", value: "quantity" },
        {
          text: "Duration Purchase quantity",
          value: "quantity"
        },
        { text: "Purchase Amount", value: "quantity" },
      ],
    };
  },
  created() {
    this.$bindAsObject("productDetail", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("godawnTrans", this.$root.$firebaseRefs.godawnTransaction.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand))
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","finYear","brandFinYear"]),
    godawnByBrand() {
      return this.godawns
        .filter((item) => {
          return (
            item["brand"] === this.selectedBrand 
          );
        });
    },
  },
  methods: {
   openGodawnReports(godawn){
     this.currentGodawn = godawn;
     this.reportProducts = [];
     this.currentGodawanTransaction = this.godawnTrans.filter(item => item['brand'] == this.selectedBrand && item['godawn'] == godawn['.key'] );
     this.currentGodawanTransaction.map((item,index)=>{
        let productIndex = this.reportProducts.findIndex(item1 => item1['.key'] == item.product);
        let temp = this.productDetail[item.product];
       if(productIndex > -1) {
           this.reportProducts[productIndex]['reportDetails'].transfer += item.quantity;
           let amount = item.quantity * Number.parseFloat(temp.sellingPrice)
           this.reportProducts[productIndex]['reportDetails'].transferAmount +=  Number.parseFloat(amount)
       } else {
           temp['reportDetails'] = {
               opening : item.quantity,
               openingAmount : item.quantity * Number.parseFloat(temp.sellingPrice),
               purchase : 0,
               purchaseAmount : 0,
               sale : 0,
               saleAmount : 0,
               transfer : 0,
               transferAmount : 0,
           }
           temp['.key'] = item.product;
           this.reportProducts.push(temp)
       }
     });
     

     let invoices = this.invoices.filter(item => (item['brand'] == this.selectedBrand && (item.date >= this.finYear.start) &&  (item.deleted != true) &&  (item.date <= this.finYear.end)));
     invoices.map((invoice,index)=>{ 
       invoice.items && invoice.items.map((item)=>{
         if(item['godawnBy'] == godawn['.key']) {
            let productIndex = this.reportProducts.findIndex(item1 => item1['.key'] == item.productId);
            let temp = this.productDetail[item.productId];
            if(productIndex > -1) {
                if(invoice.isBuyer) {
                    this.reportProducts[productIndex]['reportDetails'].sale += item.quantity;
                    let amount = item.quantity * Number.parseFloat(temp.sellingPrice)
                    this.reportProducts[productIndex]['reportDetails'].saleAmount +=  Number.parseFloat(amount)
                } else {
                    this.reportProducts[productIndex]['reportDetails'].purchase += item.quantity;
                    let amount = item.quantity * Number.parseFloat(temp.purchasingPrice)
                    this.reportProducts[productIndex]['reportDetails'].purchaseAmount +=  Number.parseFloat(amount)
                }

            } else {
                temp['reportDetails'] = {
                    opening : 0,
                    openingAmount : 0,
                    purchase : !invoice.isBuyer? item.quantity : 0,
                    purchaseAmount :  !invoice.isBuyer? item.quantity * Number.parseFloat(temp.purchasingPrice) : 0,
                    sale : invoice.isBuyer? item.quantity : 0,
                    saleAmount : invoice.isBuyer? item.quantity * Number.parseFloat(temp.sellingPrice) : 0,
                    transfer : 0,
                    transferAmount : 0,
                }
                temp['.key'] = item.product;
                this.reportProducts.push(temp)
            }
         } 
       })
     })
    
    // let finalResult = [];

    //  this.currentGodawanTransaction.map((item)=>{
    //    let index =  _.findIndex(finalResult,{productName : item.productName})
    //    if(index > -1) {
    //      finalResult[index].totalQuantity += (item.type == 'Sale' ? (-item['quantity']) : (item['quantity']))
    //    } else {
    //      item.totalQuantity = item.quantity;
    //      finalResult.push(item)
    //    }
    //  })
    //  this.currentGodawnProducts = finalResult;
     this.viewReports = true;
   },
//    renderDate(timeStamp) {
//       if (timeStamp) {
//         return new Date(timeStamp).toLocaleDateString("en-GB");
//       }
//       return "--";
//     },
  }
};
</script>

<style scoped>
.card__text.number {
  font-size: xx-large;
  font-weight: bolder;
}

.godawn-details .sec1-card {
  background-color: #ffffff !important;
  border-color: #ffffff !important;
  color: #15155d !important;
  font-weight: bold;
  font-size: 14px;
  padding: 10px;
}

.godawn-details .headline {
  font-weight: bold;
  margin-left: 70px;
}

.godawn-details .v-card__title--primary {
  padding: 5px;
}

.godawn-details .icon-card {
  width: 60px;
  height: 60px;
  z-index: 2;
  top: 30px;
  background: #15155d;
  left: 10px;
}

.godawn-details .icon-card i {
  padding: 12px;
  color: white;
}

.godawn-details .sec3-card {
  position: relative;
  bottom: 7px;
  margin-bottom: 10px;
  font-size: 20px;
  text-align: left;
  padding-left: 9px;
  color: #15155d;
  font-weight: bold;
}
/* .dashboardHead th.column.text-xs-left {
  text-align: center !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/GodownReports/GodownReports.vue